var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skill-container"},[_c('span',{staticClass:"skill-name"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_c('img',{staticClass:"close-button",attrs:{"src":"/images/close.svg"},on:{"click":_vm.handleClick}})])
}
var staticRenderFns = []

export { render, staticRenderFns }